import { render, staticRenderFns } from "./expert.vue?vue&type=template&id=07cc1a23&scoped=true&"
import script from "./expert.vue?vue&type=script&lang=js&"
export * from "./expert.vue?vue&type=script&lang=js&"
import style0 from "./expert.vue?vue&type=style&index=0&id=07cc1a23&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cc1a23",
  null
  
)

export default component.exports